/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum PathTypeEnum {
    UNFINISHED = 'UNFINISHED',
    INACTIVE = 'INACTIVE'
}
